import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { changeFormFieldValue } from 'apps/auth/actions/formAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import InputAutoDetect from 'apps/auth/components/form/InputAutoDetect';
import Form from 'apps/auth/components/form-multi/Form';
import { clearLeadingSpace, getSortFields } from 'apps/auth/components/form-multi/utils';
import AntifraudCommunicationsTermsModal from 'apps/auth/components/send/disclaimers/AntifraudCommunicationsTermsModal';
import BasePage from 'apps/auth/components/utils/BasePage';
import ModalNew from 'apps/auth/components/utils/ModalNew';
import {
    AF_PURPOSE_OF_TRANSFERS_CONTINUED_CLICKED,
    AF_TRANSACTIONS_DETAILS_CONTINUED_CLICKED,
    PERSONAL_INFO_SCREEN_SHOWN,
} from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { SCENARIO_ID } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { ANTIFRAUD_HRJ } from 'apps/auth/constants/formName';
import { AUTH_ANTIFRAUD_HSJ_FIELD_ACTION, AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';
import { useExtra, useForm, usePageMessages } from 'apps/auth/hooks/selectors';

const AntiFraudFieldsPage = (props) => {
    const { payId, ticketId, fraudScenarioId, actionId, antiFraudDisclaimer } = useExtra();
    const modalRef = useRef(null);

    const form = useForm(ANTIFRAUD_HRJ);
    const messages = usePageMessages();

    useEffect(() => {
        amplitude.getInstance().logEvent(PERSONAL_INFO_SCREEN_SHOWN);
    }, []);

    const getAmplitudeEventName = () => {
        if (Number(actionId) === 6 || Number(actionId) === 8) {
            return AF_TRANSACTIONS_DETAILS_CONTINUED_CLICKED;
        } else {
            return AF_PURPOSE_OF_TRANSFERS_CONTINUED_CLICKED;
        }
    };
    const beforeSubmit = () => clearLeadingSpace(form.fields, form.name, props.changeFormFieldValue);

    if (form) {
        return (
            <>
                <CommonPage backUrl={AUTH_SEND_MAIN_LINK}>
                    <HeaderPanel
                        title={messages.antifraudFieldsTitle}
                        subtitle={messages.antifraudFieldsSubTitle}
                        buttonRowType="link"
                        buttonRowCaption={messages.antiFraudDisclaimerTitle}
                        buttonRowOnClick={(e) => {
                            e.preventDefault();
                            modalRef.current?.open(<AntifraudCommunicationsTermsModal content={antiFraudDisclaimer} modalRef={modalRef} />);
                        }}
                    />
                    <Form
                        id="antifraud_hrj_fields"
                        formName={form.name}
                        fields={form.fields}
                        beforeSubmit={beforeSubmit}
                        action={AUTH_ANTIFRAUD_HSJ_FIELD_ACTION + ticketId + '/' + payId}
                    >
                        {getSortFields(form.fields)
                            .filter((field) => field.visible)
                            .map((field) => {
                                return (
                                    <Row indent="24px" key={field.name}>
                                        <InputAutoDetect field={field} formName={form.name} />
                                    </Row>
                                );
                            })}
                        <FixedBottomPanel isRightAligned>
                            <Button
                                type="submit"
                                raised={true}
                                caption={messages.buttonContinue}
                                onClick={() => {
                                    amplitude.getInstance().logEvent(getAmplitudeEventName(), { [SCENARIO_ID]: fraudScenarioId });
                                }}
                            />
                        </FixedBottomPanel>
                    </Form>
                </CommonPage>
                <ModalNew ref={modalRef} />
            </>
        );
    }
};

export default connect(null, { changeFormFieldValue })(BasePage(AntiFraudFieldsPage));
